<div class="outer-border mt-5">
  <mat-table #table [dataSource]="dataSource" class="table">
    <ng-container matColumnDef="tipoComissao">
      <mat-header-cell *matHeaderCellDef>Tipo de comissão</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="text-truncate">
          {{ row?.comissaoTipo?.sigla | infoLabel }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="cpf">
      <mat-header-cell *matHeaderCellDef>CPF do(a) coordenador(a)</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.coordenadorCpf | cpf | infoLabel }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="nomeCoordenador">
      <mat-header-cell *matHeaderCellDef>Coordenador(a)</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="text-truncate" matTooltip="{{ row.coordenadorNome }}">
          {{ row.coordenadorNome | infoLabel }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row" class="d-flex align-items-center pr-2 justify-content-end">
        <bdg-icon-button icon="person_off" (click)="confirmarDesvinculacaoCoordenador(row)"></bdg-icon-button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  <div *ngIf="dataSource.data.length === 0" class="w-100 border-bottom text-center table-message white-background">
    <bdg-label color="rgba(0, 0, 0, 0.54); font-style: italic;">
      Nenhum coordenador encontrado com os filtros aplicados. Confira as informações e realize outra busca.
    </bdg-label>
  </div>

  <mat-paginator
    [length]="dataSource.data.length"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 100]"
    class="mat-paginator-vinculo-instituicao"
  ></mat-paginator>
</div>
<div class="w-100" style="height: 1em"></div>
